function initFreeFittingBadge() {
  document.addEventListener('mouseover', (e) => {
    const badge = e.target.closest('[data-free-fitting-badge]');
    if (!badge) return;

    const sub = badge.querySelector('[data-free-fitting-sub]');
    if (sub && !sub.textContent.trim()) {
      sub.textContent = badge.dataset.hoverText || 'при покупке комплекта шин (4 шт.)';
    }
    badge.classList.add('_active');
  });

  document.addEventListener('mouseout', (e) => {
    const badge = e.target.closest('[data-free-fitting-badge]');
    if (!badge) return;

    if (e.relatedTarget && badge.contains(e.relatedTarget)) {
      return;
    }
    badge.classList.remove('_active');
  });

  document.addEventListener('click', (e) => {
    const badge = e.target.closest('[data-free-fitting-badge]');
    if (badge) {
      const sub = badge.querySelector('[data-free-fitting-sub]');
      if (sub && !sub.textContent.trim()) {
        sub.textContent = badge.dataset.hoverText || 'при покупке комплекта шин (4 шт.)';
      }
      badge.classList.toggle('_active');
      return;
    }

    document.querySelectorAll('[data-free-fitting-badge]._active').forEach((b) => {
      b.classList.remove('_active');
    });
  });
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreeFittingBadge);
  } else {
    initFreeFittingBadge();
  }
}

module.exports = initFreeFittingBadge;
